import { ReactElement } from 'react';
import { SkeletonBar } from './SkeletonBar';
import './Skeleton.css';

export interface SkeletonCardTileProps {
  className?: string;
}

/**
 * A single card placeholder for the PIM templates channel grid. Mirrors the real
 * channel card (fixed 200×120, image filling the box, name badge overlaid at the
 * bottom) so the skeleton occupies the exact footprint the cards resolve into.
 */
export function SkeletonCardTile({ className }: SkeletonCardTileProps): ReactElement {
  const rootClass = ['pim-skeleton-card-tile', className].filter(Boolean).join(' ');
  return (
    <div className={rootClass} aria-hidden="true">
      <SkeletonBar className="pim-skeleton-card-tile__media" height="100%" radius={0} />
      <SkeletonBar className="pim-skeleton-card-tile__badge" width={90} height={20} radius={6} strong />
    </div>
  );
}

export default SkeletonCardTile;
